import { Theme, SvgIcon } from '@mui/material';
import { Box, SxProps } from '@mui/system';
import { FC } from 'react';
import LogoDuoBlue from '../../../../logos/pxt_brand_duo-blue.svg?react';
import LogoDuoWhite from '../../../../logos/pxt_brand_duo-white.svg?react';
import LogoMonoBlack from '../../../../logos/pxt_brand_mono-black.svg?react';
import LogoMonoWhite from '../../../../logos/pxt_brand_mono-white.svg?react';

type Props = {
  variant?: 'duo-white' | 'duo-blue' | 'mono-black' | 'mono-white';
  sx?: SxProps<Theme>;
  className?: string;
};

export const Logo: FC<Props> = ({ variant, className, sx }) => {
  const getIcon = (variant: Props['variant']) => {
    switch (variant) {
      case 'mono-black':
        return LogoMonoBlack;
      case 'mono-white':
        return LogoMonoWhite;
      case 'duo-white':
        return LogoDuoWhite;

      default:
        return LogoDuoBlue;
    }
  };

  return (
    <Box className="flex flex-col justify-center items-center">
      <SvgIcon
        component={getIcon(variant)}
        inheritViewBox
        className={className}
        sx={{
          width: 'unset',
          fontSize: 'unset',
          padding: '0.75rem',
          marginX: '2rem',
          ...sx
        }}
      />
    </Box>
  );
};
